export var GRID_CLASS_PREFIX = 'Grid';
export var gridRoot = 'GridRoot';
export var GRID_RESOLUTION = 12;